import { renderAttribute } from '@cms/components/renders'
import { generateSearchParam } from '@cms/utils/helpers'
import { ISystemTag } from '@dl/declarations'
import clsx from 'clsx'
import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { TagForm } from '../../components/forms/TagForm'
import { DataPart } from '../../components/ui/DataPart'
import PageContainer from '../../components/ui/PageContainer'
import { renderRouteOptions, Routes, TagsPath } from '../../utils/routes'

const TagsPage = () => {
    const renderItem = useCallback((item: ISystemTag) => {
        return (
            <Link
                className={clsx(
                    'py-4 ps-4 pe-12 w-full',
                    'flex items-center gap-2',
                    'border border-cs-700 rounded-md',
                )}
                to={{
                    pathname: Routes.TAGS,
                    search: `?${generateSearchParam(TagsPath, "mode", "update")}&${generateSearchParam(TagsPath, "id", item._id)}`,
                }}
                key={item._id}
            >
                <h4 className='w-full max-w-1/2 text-cs-600 font-semibold'>{item.name}</h4>
                {renderAttribute({
                    title: {
                        value: "Usage count"
                    },
                    value: {
                        value: [String(item.tag_story_aggregate || 0)]
                    }
                })}
            </Link>
        )
    }, [])


    return (
        <PageContainer
            title={renderRouteOptions(Routes.TAGS).title}
        >
            <DataPart<ISystemTag>
                tableSize='full'

                distribution={{
                    type: 'grid',
                    noOfColumns: "1",
                    renderItem: renderItem,
                }}

                queryOptions={{
                    basePath: TagsPath,
                }}

                updateOptions={{
                    allow: true,
                    hide: true
                }}
                createOptions={{
                    allow: true
                }}
                searchOptions={{
                    allow: true
                }}

                form={<TagForm />}
            />
        </PageContainer>
    )
}

export default TagsPage